// const baseApi = "https://guidestar-test.frappe.cloud" // Test url 



const baseApi = "https://guidestarindia.frappe.cloud" // production Url



export { baseApi }